export default {
  AUTHORIZATION_PATH: 'authQuery',
}